export default "__VITE_ASSET__Cxy$5m7T__"